import { defaults } from "flippo";
export * from "flippo-react";

(window as any).disableFlip = () => {
    // TODO expose a way to disable flipping from flippo
    defaults.enterAnimation.durationMs = 0;
    defaults.updateAnimation.durationMs = 0;
    defaults.exitAnimation.durationMs = 0;
}